export default "__VITE_ASSET__K54YFcrQ__"